import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import type { SerializableTimestamp } from "./types"
import { Timestamp } from "firebase/firestore"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const toDate = (serializableTimestamp: SerializableTimestamp | null | undefined): Date | null => {
    if (!serializableTimestamp) return null;
    return new Timestamp(serializableTimestamp.seconds, serializableTimestamp.nanoseconds).toDate();
};
